// the files AI can read a process from, as the server expects them
export const AI_FILE_MAX_BYTES = 2000000
export const AI_FILE_ACCEPT = ".txt,.pdf,.png,.jpg,.jpeg,.xml,.xpdl,.json"
const AI_FILE_TYPES = ["text/plain", "image/png", "image/jpeg", "application/xml", "text/xml", "application/json", "application/pdf"]
const XPDL = "application/xpdl"

// the type to send with a file, or what is wrong with it. Browsers don't know xpdl, so it goes by the extension
export const checkAIFile = (file:{name:string, type:string, size:number}):{fileType:string}|{error:string} => {
    if (file.size > AI_FILE_MAX_BYTES) return {error: "Unable to load a file larger than 2MB."}
    if (AI_FILE_TYPES.includes(file.type)) return {fileType: file.type}
    if (file.type === XPDL || file.name.toLowerCase().endsWith('.xpdl')) return {fileType: XPDL}
    return {error: "Invalid file type. Must be text file, image (jpeg or png), xml, xpdl or pdf"}
}
